import React from "react";
import styled from "styled-components";

export type StatusTone = "success" | "info" | "warning" | "neutral" | "danger";

export interface StatusPillProps extends React.HTMLAttributes<HTMLSpanElement> {
	tone?: StatusTone;
	children: React.ReactNode;
}

/** §8: 28px, radius-full, 0 12px padding, 14px text. Colour pairs from §1. */
const StatusPill = ({ tone = "neutral", children, ...rest }: StatusPillProps) => (
	<Pill $tone={tone} {...rest}>
		{children}
	</Pill>
);

const grounds: Record<StatusTone, { bg: string; fg: string }> = {
	success: { bg: "var(--color-success-bg)", fg: "var(--color-text)" },
	info: { bg: "var(--color-info-bg)", fg: "var(--color-info-text)" },
	warning: { bg: "var(--color-warning-bg)", fg: "var(--color-text)" },
	neutral: { bg: "var(--color-neutral-bg)", fg: "var(--color-text)" },
	danger: { bg: "var(--color-danger)", fg: "var(--color-surface)" },
};

const Pill = styled.span<{ $tone: StatusTone }>`
	display: inline-flex;
	align-items: center;
	height: var(--size-pill);
	padding: 0 var(--space-3);
	border-radius: var(--radius-full);
	background: ${({ $tone }) => grounds[$tone].bg};
	color: ${({ $tone }) => grounds[$tone].fg};
	font-family: var(--font-family);
	font-size: var(--font-size-body);
	line-height: var(--line-height-base);
	white-space: nowrap;
`;

export default StatusPill;
